// React / Next
import { ReactNode } from 'react';

// Components
import { Typography } from '@archieai/ui';

// Utils
import { cn } from '../../utils/cn';

// Types
type CapabilityCardProps = {
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
};

export const CapabilityCard = ({
  icon,
  title,
  description,
  className,
}: CapabilityCardProps) => {
  return (
    <article
      className={cn(
        'flex flex-col gap-[var(--spacing-8)] pt-[var(--spacing-16)] px-[var(--spacing-16)] pb-[var(--spacing-24)] bg-white border border-gray-200 rounded-[var(--radius-8)] min-h-[188px] w-full',
        'transition-colors duration-200 ease-out',
        'hover:border-blue-1000 hover:bg-blue-200',
        className
      )}
    >
      <div className="w-[24px] h-[24px] text-blue-800 shrink-0 [&_svg]:w-full [&_svg]:h-full">
        {icon}
      </div>
      <Typography as="h3" variant="h4" className="text-blue-1000">
        {title}
      </Typography>
      <Typography as="p" variant="tiny" className="text-blue-1000">
        {description}
      </Typography>
    </article>
  );
};
